// src/ui/PageLayout.jsx
import React from "react";

export default function PageLayout({
  children,
  className,
  header,
  toolbar,
  showOuterHeader = true,
}) {
  return (
    <div
      className={`min-h-screen bg-[var(--mudo-bg)] text-[var(--mudo-text)] ${className || ""}`}
    >
      <div className="mx-auto max-w-[1200px] px-4 sm:px-8 lg:px-10 py-6 sm:py-8">
        {showOuterHeader && header}

        {toolbar && <div className="mt-6">{toolbar}</div>}

        <div className="mt-6">{children}</div>
      </div>
    </div>
  );
}
